import { connect } from 'react-redux'

import { saveRichCheckoutOrderRequested } from '../../actions/richCheckout/order'
import { startOfflineCardOrder, startOnlineCardOrder } from '../../actions/order'
import { clearCart } from '../../actions/cart'

import RichCheckoutContainer from '../../components/richCheckout/Container'

import { getTotal } from '../../selectors/cart'

const mapStateToProps = (state) => {
  const total = getTotal(state)

  return { total }
}

const mapDispatchToProps = (dispatch) => {
  return {
    clearCart: () => { dispatch(clearCart()) },
    onOfflineCardReaderSuccess: (cardReaderData) => {
      dispatch(startOfflineCardOrder({ cardReaderData }))
    },
    onCardReaderSuccess: (cardReaderData) => {
      dispatch(startOnlineCardOrder({ cardReaderData }))
    },
    saveRichCheckoutOrder: (data) => {
      dispatch(saveRichCheckoutOrderRequested(data))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RichCheckoutContainer)
